<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :disabled="disabled"
      :isConfirmEdit="isConfirmEdit"
      @reload="getData"
      @openEdit="openEdit"
    >
    </PageMain>
    <AddMarketplace
      v-if="showAddMarketplace"
      :type="openAddMarketplaceOption.type"
      :amzPriceControlCode="amzPriceControlCode"
      :amzPriceControlDetailCode="amzPriceControlDetailCode"
      :amzDetailMarketCode="openAddMarketplaceOption.amzDetailMarketCode"
      :disabled="disabled"
      @close="onCloseAddMarketplace"
      @reload="getData"
    ></AddMarketplace>
  </div>
</template>
<script>
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import AddMarketplace from '../edit-form/AddMarketplace.vue'
export default {
  props: {
    amzPriceControlDetailCode: String,
    amzPriceControlCode: String,
    isConfirmEdit: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  mixins: [BaseTable],
  components: { PageMain, AddMarketplace },
  data() {
    return {
      usePage: false,
      showAddMarketplace: false,
      openAddMarketplaceOption: {
        type: '',
        amzDetailMarketCode: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    onCloseAddMarketplace() {
      this.showAddMarketplace = false
    },
    getData() {
      this.loading = true
      this.$api
        .ecomAmzPriceControlDetailMarketListApi({
          amzPriceControlDetailCode: this.amzPriceControlDetailCode,
          amzPriceControlCode: this.amzPriceControlCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEdit({ pageType, amzDetailMarketCode }) {
      this.openAddMarketplaceOption.type = pageType
      this.openAddMarketplaceOption.amzDetailMarketCode = amzDetailMarketCode
      this.showAddMarketplace = true
    },
  },
}
</script>
